import { OxCoreVideoPlayer } from './OxCoreVideoPlayer';

export * from './OxCoreVideoPlayer';
export default OxCoreVideoPlayer;
